var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SkipLinksCore = (props) => {
    const { Anchor, Container, List, ListItem } = props.components;
    const renderItems = (links) => {
        return links.map((link, key) => {
            const { label } = link, rest = __rest(link, ["label"]);
            return (React.createElement(ListItem, { key: key },
                React.createElement(Anchor, Object.assign({}, rest, { isTextColor: true, isUnderlined: false, className: "skip-links__anchor", attributes: {
                        onFocus: props.setHeaderHeight,
                        onBlur: props.setHeaderHeight,
                    } }), label)));
        });
    };
    return (React.createElement("div", { className: "skip-links" },
        React.createElement(Container, null,
            React.createElement(List, { bordered: true, direction: "inline", type: "unstyled", className: "skip-links__list" }, renderItems(props.links)))));
};
export default SkipLinksCore;
